import { Component } from '@angular/core';
import { ScrBaseComponent } from '../../base.component';
import { CacheService } from '../../../services';
import { BadgeData } from '../../../models/badge.model';
import { BADGECOUNTS } from '../../../shared/constants';

@Component({
  templateUrl: './partner-library.component.html'
})
export class PartnerLibraryComponent extends ScrBaseComponent {

  brandCount = 0;
  contentProviderCount = 0;

  constructor(private cacheService: CacheService) {
    super();

    this.subscriptions.push(this.cacheService.subscribe<BadgeData>(BADGECOUNTS).subscribe(badgecounts => {
      if (badgecounts) {
        this.brandCount = badgecounts.brandCount;
        this.contentProviderCount = badgecounts.contentProviderCount;
      }
    }));
  }
}
